/* GBE V4 approved Condition + Warranty rules for TV Model Parts and TV Spare Parts only. */
(function () {
  'use strict';
  if (window.GBEConditionWarrantyRulesV4) { window.GBEConditionWarrantyRulesV4.refresh(); return; }

  function norm(value) {
    return String(value || '').normalize('NFKC').toLowerCase()
      .replace(/[\u200b-\u200d\ufeff]/g, '')
      .replace(/[\u2010-\u2015\u2212-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function label(value) { return norm(value).replace(/[^a-z0-9]+/g, ' ').trim(); }

  function partKey(value) {
    var s = label(value);
    if (!s) return '';
    if (s.indexOf('universal') !== -1 || s === 'china board' || s === 'china boards') return 'universal';
    if (s.indexOf('backlight') !== -1) return 'backlight';
    if (s.indexOf('motherboard') !== -1 || s.indexOf('main board') !== -1) return 'motherboard';
    if (s.indexOf('power supply') !== -1 || /\bsmps\b/.test(s) || /\bpsu\b/.test(s)) return 'power_supply';
    if (s.indexOf('t con') !== -1 || s.indexOf('tcon') !== -1 || s.indexOf('timing control') !== -1 || s.indexOf('ticon') !== -1) return 'tcon';
    if (s.indexOf('cof scaler') !== -1 || s.indexOf('scaler') !== -1) return 'scaler';
    if (s.indexOf('lvds') !== -1 || s.indexOf('display signal cable') !== -1) return 'lvds';
    if (s.indexOf('ffc') !== -1 || s.indexOf('flat ribbon') !== -1 || s.indexOf('flat flexible') !== -1) return 'ffc';
    if (s.indexOf('wi fi') !== -1 || s.indexOf('wifi') !== -1 || s.indexOf('wireless lan') !== -1 || s.indexOf('wlan') !== -1) return 'wifi';
    if (s.indexOf('ir sensor') !== -1 || s.indexOf('remote receiver') !== -1 || s.indexOf('infrared') !== -1 || s.indexOf('key board') !== -1) return 'ir';
    if (s.indexOf('led driver') !== -1) return 'led_driver';
    if (s.indexOf('inverter') !== -1) return 'inverter';
    return '';
  }

  var rules = {
    motherboard:  { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    power_supply:{ condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    led_driver:  { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    inverter:    { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    tcon:        { condition: 'Pre-Owned', warranty: 'No Warranty', noReturns: true },
    scaler:      { condition: 'Pre-Owned', warranty: 'No Warranty' },
    backlight:   { condition: 'New', warranty: '6-Month Replacement' },
    ir:          { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    wifi:        { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    lvds:        { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    ffc:         { condition: 'Pre-Owned', warranty: '1-Month Replacement' },
    universal:   { condition: 'New', warranty: 'No Warranty' }
  };

  function rowByLabel(list, wanted) {
    if (!list) return null;
    return Array.prototype.find.call(list.querySelectorAll(':scope > .gbe-spec-row'), function (row) {
      var dt = row.querySelector(':scope > dt');
      return dt && label(dt.textContent) === wanted;
    }) || null;
  }

  function resolve(page) {
    var area = page.querySelector('.gbe-model-details, .gbe-product-description');
    if (!area) return null;
    var list = area.querySelector('.gbe-content .gbe-spec-list');
    var partRow = rowByLabel(list, 'part type');
    if (!partRow) return null;
    var dd = partRow.querySelector(':scope > dd');
    var key = partKey(dd && dd.textContent);
    return { area: area, list: list, partRow: partRow, key: key, rule: rules[key] || null };
  }

  function setCondition(info) {
    var list = info.list;
    var current = rowByLabel(list, 'condition');
    if (!info.rule) {
      if (current && current.hasAttribute('data-gbe-condition-spec-row')) current.remove();
      return;
    }
    if (!current) {
      current = document.createElement('div');
      current.className = 'gbe-spec-row';
      current.setAttribute('data-gbe-condition-spec-row', 'approved-rule');
      var dt = document.createElement('dt');
      dt.textContent = 'Condition';
      var dd = document.createElement('dd');
      current.appendChild(dt);
      current.appendChild(dd);
      info.partRow.insertAdjacentElement('afterend', current);
    }
    current.setAttribute('data-gbe-condition-spec-row', 'approved-rule');
    var value = current.querySelector(':scope > dd');
    if (value) value.textContent = info.rule.condition;
    if (current.previousElementSibling !== info.partRow) info.partRow.insertAdjacentElement('afterend', current);
  }

  function hasChip(row, textValue) {
    var wanted = norm(textValue);
    return Array.prototype.some.call(row.querySelectorAll('.gbe-trust-chip'), function (chip) {
      return norm(chip.textContent) === wanted;
    });
  }

  function setWarrantyChip(info) {
    var row = info.area.querySelector('.gbe-hero .gbe-trust-row');
    if (!row) return;
    row.querySelectorAll('[data-gbe-approved-warranty-chip]').forEach(function (n) { n.remove(); });
    if (!info.rule) return;
    var needsClientChip = /^(ir|wifi|lvds|ffc|universal)$/.test(info.key);
    if (!needsClientChip || hasChip(row, info.rule.warranty)) return;
    var chip = document.createElement('div');
    chip.className = 'gbe-trust-chip';
    chip.setAttribute('data-gbe-approved-warranty-chip', info.key);
    chip.textContent = info.rule.warranty;
    var secure = Array.prototype.find.call(row.querySelectorAll('.gbe-trust-chip'), function (n) { return norm(n.textContent) === 'secure packing'; });
    row.insertBefore(chip, secure || null);
  }

  function warrantyCopy(key) {
    if (key === 'universal') return { heading: 'No warranty', copy: 'Universal Boards are supplied new and carry no warranty.' };
    if (key === 'lvds') return { heading: '1-month replacement warranty', copy: 'This LVDS / display signal cable carries a 1-month replacement warranty, subject to the Great Bharat Electronics warranty policy and eligibility verification. Physical damage, bent contacts or damaged pins caused during handling or installation are not covered.' };
    if (key === 'ffc') return { heading: '1-month replacement warranty', copy: 'This FFC / flat ribbon cable carries a 1-month replacement warranty, subject to the Great Bharat Electronics warranty policy and eligibility verification. Physical damage, torn conductors, bent contacts or damaged pins caused during handling or installation are not covered.' };
    if (key === 'ir') return { heading: '1-month replacement warranty', copy: 'This IR Sensor / Remote Receiver carries a 1-month replacement warranty, subject to the Great Bharat Electronics warranty policy and eligibility verification.' };
    if (key === 'wifi') return { heading: '1-month replacement warranty', copy: 'This Wi-Fi / Wireless LAN Module carries a 1-month replacement warranty, subject to the Great Bharat Electronics warranty policy and eligibility verification.' };
    return null;
  }

  function setWarrantyDetail(info) {
    var copy = warrantyCopy(info.key);
    if (!copy) return;
    var accordion = info.area.querySelector('[aria-labelledby^="model-info-"] .gbe-accordion, [aria-labelledby^="gbe-information-title-"] .gbe-accordion');
    if (!accordion) return;

    var matches = Array.prototype.filter.call(accordion.querySelectorAll(':scope > details'), function (d) {
      var summary = d.querySelector(':scope > summary');
      var s = norm(summary && summary.textContent);
      if (d.hasAttribute('data-gbe-approved-warranty-detail')) return true;
      if (s === norm(copy.heading)) return true;
      if ((info.key === 'lvds' || info.key === 'ffc') && s === 'cable handling and coverage') return true;
      if (info.key === 'universal' && s === 'universal board sales policy') return true;
      return false;
    });

    var details = matches.shift() || null;
    matches.forEach(function (duplicate) { duplicate.remove(); });

    if (!details) {
      details = document.createElement('details');
      var before = Array.prototype.find.call(accordion.querySelectorAll(':scope > details'), function (d) {
        var summary = d.querySelector(':scope > summary');
        return norm(summary && summary.textContent) === 'before you order';
      });
      accordion.insertBefore(details, before || null);
    }

    details.setAttribute('data-gbe-approved-warranty-detail', info.key);
    details.innerHTML = '';
    var summary = document.createElement('summary');
    summary.textContent = copy.heading;
    var content = document.createElement('div');
    content.className = 'gbe-accordion-content';
    var p = document.createElement('p');
    p.textContent = copy.copy;
    content.appendChild(p);
    details.appendChild(summary);
    details.appendChild(content);
  }

  function refresh() {
    document.querySelectorAll('.page-product-template').forEach(function (page) {
      var root = page.querySelector('[data-gbe-model-product-root], [data-gbe-tv-spare-product-root]');
      if (!root) return;
      var info = resolve(page);
      if (!info) return;
      setCondition(info);
      setWarrantyChip(info);
      setWarrantyDetail(info);
    });
  }

  window.GBEConditionWarrantyRulesV4 = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  window.addEventListener('load', refresh, { once: true });
  document.addEventListener('shopify:section:load', refresh);
})();
